import React, { useState } from "react";
import {
  Table,
  Button as But,
  Modal,
  Spin,
  notification,
  Form,
  Row,
  Col,
} from "antd";
import liracrypt from "../Liracrypt/liracrypt";
import Button from "../ReportFormGenerator/Button/Button";
import Int from "../ReportFormGenerator/Int/Int";
import UnifiedInput from "../../components/ReportFormGenerator/UnifiedInput/UnifiedInput";

import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  LoadingOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import UniDropAdv from "../ReportFormGenerator/UniDrop/UniDropAdv";
import StAddNew from "../../pages/DSeries/StAddNew";

const axios = require("axios");
const productionTableStyle = {
  marginTop: "1rem",
  marginBottom: "1rem",
};

function OnlineReport(props) {
  const [form] = Form.useForm();
  const [FormData, setFormData] = useState(null);
  props.setPageHeader("Online Defect Entry");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalHeader, setModalHeader] = useState("");
  const [editData, setEditData] = useState(null);
  const [successButtonText, setSuccessButtonText] = useState("");

  const [requestType, setRequestType] = useState("GET");

  const [loadingDone, setLoadingDone] = useState(false);

  const [searchVisible, setSearchVisible] = useState(false);

  const [dataSource, setDataSource] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);

  const [actualDisabled, setActualDisabled] = useState([]);
  const [disabledList, setDisabledList] = useState([]);
  const [visibleIcon, setVisibleIcon] = useState([]);

  const [buttonLoading, setButtonLoading] = useState(false);

  const [quan, setQuan] = useState(null);

  const onFinish = (values) => {
    values["lid"] = props.lid;
    // values["dt"] = values["dt"].format("YYYY/MM/DD").toString();
    //   values["nxtDt"] = values["nxtDt"].format("YYYY/MM/DD").toString();
    setButtonLoading(true);
    liracrypt
      .post("/quality/onlinedefectentry", values)
      .then((res, req) => {
        if (res.data.isSuccess) {
          setButtonLoading(false);
          if (props.fetchAndonDetail) {
            props.fetchAndonDetail();
          }
          openNotificationWithIcon("success", "Document Inserted Successful");
          // setRequestType("GET");

          // form.submit();
          form.resetFields();
          setQuan(null);
        } else {
          openNotificationWithIcon("error", "Document Insert Failed");
          setButtonLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setButtonLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
    setFormData(values);

  };
  const productionTableStyle = {
    marginTop: "1rem",
    marginBottom: "1rem",
  };
  const Tables = () => { };
  const openNotificationWithIcon = (type, title, desc) => {
    notification[type]({
      message: title,
      description: desc ? desc : null,
    });
  };

  React.useEffect(() => {
    // form.setFieldsValue("lid", props.lid ? props.lid : "");
  });

  return (
    <>
      <StAddNew
        extraData={{ lid: props.lid }}
        urlEndpoint={"/miscellaneous/pageconfig"}
        urlData={{ dictName: 'LD_Tab_Quality' }}
        formName={"OnlineDefectEntry"}
        initForm={form}
        colSpan={18}
        onFormSubmit={onFinish}
      />
      <Button
        formName={"OnlineDefectEntry"}
        // marginLeft={"130px"}
        form={form}
        loading={buttonLoading}
        cancelButtonText={"Cancel"}
        submitButtonText={"Submit"}
        resetButton={true}
      />
      {/* <Tables /> */}
    </>
  );
}

export default OnlineReport;
